/** Official Millet social profiles — shared by Footer and SocialMediaLinks */
export const MILLET_SOCIAL_LINKS = [
  {
    id: 'linkedin',
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/millet-ai/',
    brandColor: '#0A66C2',
  },
  {
    id: 'x',
    name: 'X (Twitter)',
    shortLabel: 'X',
    href: 'https://x.com/get_millet',
    brandColor: '#000000',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    href: 'https://www.tiktok.com/@millet_usa',
    brandColor: '#FE2C55',
  },
];

export const X_ICON_PATH = 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z';
